<template>
    <el-dialog class="dialog-custom" :class="{ 'dialog-custom-small': modalSmall, 'dialog-custom-large': modalLarge }" :visible.sync="show" :before-close="handleClose">
        <template slot="title">
            <h5 class="modal-title">
                {{ originalTitle ? originalTitle : $t(title) }}
            </h5>
        </template>
        <slot name="content"></slot>
        <div slot="footer" class="dialog-footer">
            <slot name="footer"></slot>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'Popup',
    data: function () {
        return {};
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        originalTitle: {
            type: String,
            default: ''
        },
        isCenter: {
            type: Boolean,
            default: false
        },
        modalSmall: {
            type: Boolean,
            default: false
        },
        modalLarge: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        close() {
            this.$emit('update:show', false);
        },
        handleClose() {
            this.$emit('update:show', false);
        }
    }
};
</script>
